import ProductTypePanel from './ProductTypePanel';
export default ProductTypePanel;
